import { EffiePatternWrapper } from "@components/styles"
import { styled, theme } from "@theme/stitches.config"
import Button from "@components/Button"

export const StyledEffiePatternWrapper = styled(EffiePatternWrapper, {
    top: "60%",
    zIndex: 1,
    overflow: "hidden",
    pointerEvents: "none"
})

export const HeroWrapper = styled("div", {
    display: "flex",
    position: "relative",
    zIndex: 0,
    variants: {
        goldHero: {
            true: {
                backgroundColor: theme.colors.effieGoldBackground,
                [`${StyledEffiePatternWrapper}`]: {
                    top: "50%",
                    opacity: 0.2
                },
                "h1, .h1, h2, .h2, h3, .h3": {
                    color: theme.colors.N0
                },
                ".overline": {
                    color: theme.colors.effieBackground
                }
            }
        }
    }
})

export const Content = styled("div", {

})

export const HeroContainer = styled("div", {
    py: 60,
    width: "100%",
    maxWidth: 650,
    zIndex: 1,
    display: "flex",
    alignItems: "center",
    "@mdDown": {
        flexWrap: "wrap"
    },
    "@smDown": {
        px: 0
    },
    "@lgUp": {
        mt: 100,
        pt: 150,
        mb: 80
    },
    "& p": {
        color: theme.colors.fadedText
    },
    "& h3": {
        wordBreak: "break-all"
    },
    variants: {
        isFrontpage: {
            true: {
                height: "calc(100vh - 250px)"
            }
        },
        showContentAside: {
            true: {
                flexDirection: "row"
            },
            false: {
                flexDirection: "column",
                alignItems: "flex-start"
            }
        }
    }
})

export const CircleButton = styled(Button, {
    position: "absolute",
    bottom: 0,
    right: "10%",
    transform: "translateY(50%)"
})
